import Service from "./Service"
import trust from "../../assets/images/webpages/trust.svg"
import presence from "../../assets/images/webpages/presence.svg"
import newclients from "../../assets/images/webpages/newclients.svg"
import discover from "../../assets/images/webpages/discover.svg"

import calendar from "../../assets/images/toCheck/calendar.svg"
import blog from "../../assets/images/toCheck/blog.svg"
import autoadministrable from "../../assets/images/toCheck/autoadministrable.svg"
import gallery from "../../assets/images/toCheck/gallery.svg"
import videos from "../../assets/images/toCheck/videos.svg"
import testimonials from "../../assets/images/toCheck/testimonials.svg"
import chatbot from "../../assets/images/toCheck/chatbot.svg"
import map from "../../assets/images/toCheck/map.svg"
import calc from "../../assets/images/toCheck/calc.svg"
import form from "../../assets/images/toCheck/form.svg"
import reservation from "../../assets/images/toCheck/reservation.svg"
import other from "../../assets/images/toCheck/other.svg"
import brain from "../../assets/images/webpages/brain-website-bg.svg"



const webpages = {
    t1: 'websites_title',
    header: ['websites_header1', 'websites_header2', 'websites_header3'],
    time: 'websites_time',
    brain: brain,
    benefits: [
        {
            img: trust,
            text: 'websites_benefits1'
        },
        {
            img: presence,
            text: 'websites_benefits2'
        },
        {
            img: newclients,
            text: 'websites_benefits3'
        },
        {
            img: discover,
            text: 'websites_benefits4'
        }
    ],
    info: 'websites_info',
    toCheck: [
        {
            id: 'blog',
            text: 'websites_check1',
            img: blog,
        },
        {
            id: 'edit',
            text: 'websites_check2',
            img: autoadministrable,
        },
        {
            id: 'calendar',
            text: 'websites_check3',
            img: calendar,
        },
        {
            id: 'gallery',
            text: 'websites_check4',
            img: gallery,
        },
        {
            id: 'videos',
            text: 'websites_check5',
            img: videos,
        },
        {
            id: 'testimonials',
            text: 'websites_check6',
            img: testimonials,
        },
        {
            id: 'chat',
            text: 'websites_check7',
            img: chatbot,
        },
        {
            id: 'map',
            text: 'websites_check8',
            img: map,
        },
        {
            id: 'calc',
            text: 'websites_check9',
            img: calc,
        },
        {
            id: 'formularios',
            text: 'websites_check10',
            img: form,
        },
        {
            id: 'reservas',
            text: 'websites_check11',
            img: reservation,
        },
        {
            id: 'another',
            text: 'websites_check12',
            img: other,
        },
    ]
}


const WebPages = () => {
    return (
        <Service service={webpages}/>
    )    
}

export default WebPages